<template>
  <modal
    class="addRetainershipModal"
    name="addRetainershipModal"
    transition="pop-out"
    :width="modalWidth"
    :height="400"
  >
    <div class="retainership__box">
      <button type="button" class="close modal-close" aria-label="Close" @click="closeAddRetainershipModal">
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="text-center">
        <h3 class="add__retainership__header mt-5">
          <span>
            <img src="@/assets/img/Group 484.png" width="50px" />
          </span>
          {{$t('text.addExisting.title')}}
        </h3>
        <div class="add__retainership__form__wrapper">
          <div class="form_input_section mt-4">
            <div class="input__div" ref="email_input_div">
              <div class="placeholder_div">
                <img
                  src="@/assets/img/email.png"
                  width="50%"
                  class="input_placeholder_icon"
                />
              </div>
              <div class="input_field_section">
                <input
                  type="email"
                  :placeholder="$t('text.addExisting.email')"
                  v-model="email"
                />
              </div>
            </div>
          </div>
          <div ref="email_error_message"></div>
          <div class="text-center mt-5">
            <button
              class="add_quick_fuel_btn"
              @click="addRetainership($event)"
              :disabled="isButtonDisabled ? true : null"
              :style="[
                isButtonDisabled
                  ? { cursor: 'not-allowed' }
                  : { cursor: 'pointer' }
              ]"
            >
              {{$t('text.addExisting.add')}} <span></span>
            </button>
            <img
              src="@/assets/img/git_loader.gif"
              style="display:none"
              width="35px"
              class="ml-3 loader"
            />
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

const MODAL_WIDTH = 656;

export default {
  name: "DemoLoginModal",
  props: ["company"],
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      email: null,
      isButtonDisabled: false
    };
  },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  methods: {
    validEmail(email) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return true;
      }
      return false;
    },
    closeAddRetainershipModal() {
      this.$modal.hide("addRetainershipModal");
    },
    addRetainership($event) {
      $event.preventDefault();
      if (!this.email) {
        this.$toast.open({
          message: this.$t('text.errors.emailMissing'),
          type: "error",
          duration: 3000
        });
        return
      }
      if (!this.validEmail(this.email)) {
        this.$toast.open({
          message: this.$t('text.errors.invalidEmail'),
          type: "error",
          duration: 3000
        });
        return
      }
      // let companyID;
      // if (localStorage.getItem("companyDetails") !== null) {
      //   companyID = JSON.parse(localStorage.getItem("companyDetails")).id;
      // }
      let data = {
        email: this.email,
        companyId: this.company.id
      };

      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Company/CorporateCustomers/${this.company.id}/?email=${this.email}`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.$toast.open({
            message: this.$t('text.addExisting.successfullyAdded'),
            type: "success",
            duration: 5000
          });
          $(".loader").hide();
          this.isButtonDisabled = false;
          data = null;
          this.email = null;
          this.closeAddRetainershipModal();
          this.$eventHub.$emit("getRetainerships");
        })
        .catch(error => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000
          });
          this.closeAddRetainershipModal();
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    }
  }
};
</script>
